<template>
  <div>
    <v-form ref="form" lazy-validation
      ><div class="title text-h6 px-3">
        ADD EVENT TYPE
      </div>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="data.name"
              label="Name"
              placeholder="Enter Name"
              :rules="[rules.required]"
              v-bind="basic"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="data.color"
              label="Color"
              placeholder="Enter Color"
              :rules="[rules.required]"
              v-bind="basic"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              v-model="data.description"
              label="Description"
              placeholder="Description"
              :rules="[rules.required]"
              v-bind="basic"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              elevation="2"
              large
              v-on:click="storeEventType"
              block
              v-bind="basic"
              >Add Event Type</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import util from "@/util/util";
export default {
  data() {
    return {
      data: {},
      rules: util.validation,
      basic: util.input.basic,
    };
  },
  methods: {
    storeEventType() {
      if (this.$refs.form.validate()) {
        util.loader(1);
        util
          .http({ url: "event-type", method: "post", data: this.data })
          .then((res) => {
            util.loader(0);
            if (res.data.status == 1) {
              util.notify(1, "Event Type Stored");
              this.data = {};
              this.$emit("closeDialog");
              this.$emit("fetchEventTypes");
            } else {
              util.notify(0, res.data.errors[0]);
            }
          });
      }
    },
  },
};
</script>
<style>
.title {
  background: #1d2b58 !important;
  color: #fff;
}
</style>
